import React, { useEffect, useState } from "react";

const ImeiReportHistory = ({ item, onSelect, index }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [showNote, setShowNote] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    onSelect(index, item);
  };
  const [invoiceToggle, setInvoiceToggle] = useState(false);
  useEffect(() => {}, [invoiceToggle]);

  return (
    <div className="grid grid-cols-[20px_repeat(5,_1fr)] md:grid-cols-[20px_30px_repeat(10,_1fr)]  md:gap-2 gap-2 items-center justify-start font-nunito font-[500] text-[12px] text-[#000232] border-t-[1px] border-solid border-[#E7EBF4] py-[8px]">
      {/* <div className="border-t-[1px] border-solid border-[#E7EBF4] py-[8px] font-nunito font-[500] text-[#000232] grid grid-cols-7 items-start"> */}
      <input
        type="checkbox"
        onChange={handleCheckboxChange}
        checked={item?.completed}
        className="hidden md:block text-start justify-start w-fit"
      />

      {/* Index with hover note popup */}
      <div
        className="relative font-[500] text-[#000232] text-left cursor-pointer z-50"
        onMouseEnter={() => setShowNote(true)}
        onMouseLeave={() => setShowNote(false)}
      >
        #{index + 1}

        {/* Popup tooltip */}
        {showNote && (
          <div className="absolute left-6 top-[-5px] md:top-[-10px] z-50 bg-white border border-gray-300 shadow-lg rounded-md px-3 py-2 text-[12px] text-gray-700 w-[180px] break-words transition-opacity duration-200">
            {item?.note && item.note.trim() !== "" ? (
              <>{item.note}</>
            ) : (
              <span className="italic text-gray-400">No note found</span>
            )}
          </div>
        )}
      </div>

      <div>
        <p className="text-start font-[700] text-[#87889E]">{item?.date}</p>
      </div>

      <div className="hidden md:block">
        <p className="text-center">{item?.brand_name}</p>
      </div>
      <div>
        <p className="text-start break-words whitespace-normal">
          <span className="hidden md:block">{item?.product_name && `${item.product_name} `}</span>
          {item?.color && `${item.color} `}
          {item?.storage && `${item.storage} `}
          {item?.battery_life != null && `(${item.battery_life}%) `}
          {item?.region && `(${item.region})`}
        </p>
      </div>
      {/*                     <div >
                      <p className='text-start'>{item?.color}</p>
                    </div>
                    <div >
                      <p className='text-start'>{item?.storage}</p>
                    </div>
                    <div >
                      <p className='text-start'>{item?.battery_health}</p>
                    </div> */}
      <div
        className={`
          ${item?.sale_return_id ? "bg-green-400/50" : ""}
          ${item?.purchase_return_id ? "bg-yellow-400/50" : ""}
          text-start p-1 rounded
        `}
      >
        <p>{item?.imei}</p>
      </div>
      <div className="hidden md:block ">
        <p
          className="text-center"
          onClick={() => {
            setInvoiceToggle(true);
          }}
        >
          {invoiceToggle
            ? item.sale_invoice || item.purchase_invoice
            : item.purchase_invoice || "N/A"}
        </p>
      </div>
      <div>
        <p className="text-right">{item?.purchase_price}</p>
      </div>
      <div className="hidden md:block ">
        <p className="text-center">{item?.sale_price}</p>
      </div>
      <div className="hidden md:block ">
        <p className="text-center">
          {item?.product_condition
            ? item.product_condition.charAt(0).toUpperCase() +
              item.product_condition.slice(1)
            : "N/A"}
        </p>
      </div>
      <div>
        <p className="text-center">{item?.vendor_name}</p>
      </div>
      <div className="hidden md:block ">
        <p className="text-center">{item?.customer_name}</p>
      </div>
    </div>
  );
};

export default ImeiReportHistory;
